module.exports = __webpack_public_path__ + "static/NSW-04fdb3d583ce2764b17680bdb35c8d11.svg";